import React from "react";
import { HeroContent, Hero } from "../index";

const Section1 = () => {
  return (
    <section className="flex flex-1 flex-col-reverse sm:flex-row w-full justify-center px-4  items-center my-12  ">
      <HeroContent />
      <Hero />
    </section>
  );
};

export default Section1;
